import { graphql } from '@graphql/gql';

// WARNING: any updates to agenda response structure should also be done in 'updateAgendaItems.js'
export const SEARCH_SCHEDULE = graphql(`
  query SEARCH_SCHEDULE(
    $criteria: MyAgendaCriteria
    $virtualAttendee: Boolean
    $enableSessionCapacity: Boolean!
    $enableSessionFee: Boolean!
  ) {
    myAgenda(criteria: $criteria) {
      pagination {
        limit
        totalCount
        nextToken
        currentToken
      }
      data {
        id
        name
        description
        start
        end
        status
        enrolled
        included
        virtual
        virtualLink
        openForRegistration
        featured
        contentTags {
          name
        }
        category {
          id
          name
        }
        location {
          id
          name
          code
        }
        exhibitors {
          id
          name
          description
          profileLogoUrl
          featured
        }
        webcast {
          id
          eventId
          sessionId
          format
          title
          sourceId
          provider
          meetingId
          details
          playerType
          type
          simulatedLive
          onDemandVideo
          isOnDemandContentPlayable
          solutionType
          player {
            id
            playerTypeProvider
            duration
            simuliveOffset
            stream {
              id
              status
            }
          }
        }
        type
        capacity(virtualAttendee: $virtualAttendee) @include(if: $enableSessionCapacity) {
          active
          availableCapacity
          totalCapacityAvailable
        }
        fee @include(if: $enableSessionFee) {
          amount
        }
        openForAttendeeHub
        participants {
          id
          firstName
          lastName
          type
        }
        requesters {
          firstName
          lastName
          status
        }
        requestees {
          firstName
          lastName
          status
        }
        apptType {
          category
          timeSlotType
        }
        conflict
        availableAttendeeActions {
          accept
          decline
        }
      }
    }
  }
`);
